<template>
    <div>
        
<!-- Navbar -->
<nav class="navbar px-3" :style="navStyle">
  <div class="container-fluid d-flex justify-content-between align-items-center">

    <!-- زر المنيو + البحث -->
    <div class="d-flex align-items-center">
      <!-- زر الهامبرغر يتحول إلى X -->
      <button class="btn p-0" id="menuToggleBtn" type="button" data-bs-toggle="offcanvas" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu">
        <i id="menuIcon" class="bi bi-list" style="font-size: 1.6rem; color: #857e7e;"></i>
      </button>

      <!-- أيقونة البحث - فقط للشاشات المتوسطة وما فوق -->
      <a    @click="search_open=true" class="btn p-0 ms-3 d-none d-md-inline">
        <i class="bi bi-search" style="font-size: 1.1rem; color: #857e7e;"></i>
      </a>
    </div>

    <!-- الشعار -->
    <img :src="this.$store.state.logo" class="logo">

    <!-- أيقونات المستخدم والسلة -->
    <div class="d-flex align-items-center">
      <!-- أيقونة البحث - للموبايل -->
      <a href="#" @click="search_open=true" class="btn p-0 me-2 d-inline d-md-none">
        <i class="bi bi-search" style="font-size: 1.1rem; color: #857e7e;"></i>
      </a>
      <!-- المستخدم -->
      <router-link v-if="this.$localStorage.get(this.$store.storeName) == null" :to="{
              name: 'login',
              params: { storeName: this.$store.storeName,lang: $i18n.locale },
            }"  class="btn btn-link text-dark me-2 p-0 ms-3 d-none d-md-inline">
        <i class="bi bi-person" style="font-size: 1.5rem; color: #857e7e;"></i>
      </router-link>

       <router-link v-else :to="{
              name: 'profile',
              params: { storeName: this.$store.storeName,lang: $i18n.locale },
            }"
             class="btn btn-link text-dark me-2 p-0 ms-3 d-none d-md-inline">
        <i class="bi bi-person" style="font-size: 1.5rem; color: #857e7e;"></i>
       </router-link>
      <!-- السلة -->
      <router-link :to="{
              name: 'shoppingCart',
              params: { storeName: this.$store.storeName,lang: $i18n.locale },
            }" class="btn btn-link text-dark">
        <i class="bi bi-bag" style="font-size: 1.3rem; color: #857e7e;"></i>
        <span v-if="this.$store.state.cartCounter>0" class="cart-badge"> {{ this.$store.state.cartCounter }}</span>

      </router-link>
    </div>

  </div>
</nav>
<nav v-if="search_open" class="navbar px-3" style="padding-top: 30px; padding-bottom: 60px; background-color: #FCFEF1;">
  <div class="container-fluid d-flex justify-content-between align-items-center">

    <div role="search" class="input-group " id="search_open">
      <h2 class="close_serach" @click="search_open=false">X</h2>
                <input type="search" class=""
                  :aria-label="$t('search')" aria-describedby="search-addon" v-model="word" @keyup.enter="searchRoute"
                  id="search" autocomplete="false" onblur="this.setAttribute('readonly', 'readonly') , word=''"
                  onfocus="this.removeAttribute('readonly');" readonly data-search-type="products_only" data-limit="5"
                  data-display-image="true" data-display-description="false" data-display-extra-link="true"
                  data-display-detail="true" data-order-by="name asc">
                <div class="te_header_search_close te_srch_close_ept" style="z-index: 100; display: none;">
                  <a @click="searchRoute">
                    <span class="search_btn_close_ept">x</span>
                  </a>
                </div>
                <button type="submit" aria-label="Search" title="Search"
                  class="oe_search_button btn-primary but_search">
                  <i class="fa fa-search" style="font-size: 20px;color: white ;font-weight: normal"></i>
                </button>
              </div>


  </div>
</nav>

<!-- القائمة الجانبية -->
<div class="offcanvas offcanvas-start" tabindex="-1" id="sidebarMenu" aria-labelledby="sidebarMenuLabel" style="width: 400px; background-color: white;">
<!-- رأس القائمة (X والبحث) - بعد التقريب -->
<div class="offcanvas-header justify-content-between align-items-center  sticky-top px-3" style="z-index: 1031;background-color: #FCFEF1; padding: 50px;" >
  <div class="d-flex align-items-center gap-3">
    <!-- زر الإغلاق -->
    <button type="button" class="btn p-0"  @click="closeOffcanvas">
      <i class="bi bi-x-lg" style="font-size: 1.3rem; color: black;"></i>
    </button>
    <!-- زر البحث -->
    <button @click="closeOffcanvas;search_open=true;" class="btn p-0" type="button">
      <i class="bi bi-search" style="font-size: 1.3rem; color: black;"></i>
    </button>
  </div>
</div>


  <!-- جسم القائمة -->
  <div class="offcanvas-body d-flex flex-column justify-content-between px-3 py-2"  style="background-color: #FCFEF1;;">
    <!-- الروابط -->
    <ul v-if="show" class="list-unstyled mt-2">
      <li><router-link  class="nav-link py-2 active" 
         @click.native="closeOffcanvas"
               :to="{
                  name: 'home',
                  params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }">

                  {{ $t('home') }}
                </router-link></li>
      <li><a @click="show2=true;show=false" class="nav-link py-2">{{$t('shop')}} 
        <span class="float-end arrow_left"> →</span>
        <span class="float-end arrow_right"> ←</span>
      </a></li>
      <!-- <li><router-link  @click.native="closeOffcanvas" :to="{
                  name: 'sizes',
                  params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }"  class="nav-link py-2">{{ $t('sizes') }}</router-link></li> -->

                  <!-- <li><router-link :to="{
                  name: 'sections',
                  params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }"  @click.native="closeOffcanvas" class="nav-link py-2">{{ $t('sections') }}</router-link></li> -->

                
                  <li><router-link :to="{
                  name: 'products',
                  params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }"   @click.native="closeOffcanvas" class="nav-link py-2">{{ $t('products') }}</router-link></li>

      <!-- <li><router-link :to="{
                  name: 'contactUs',
                  params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }" class="nav-link py-2">{{$t('contactUs')}}</router-link></li> -->
      <li><router-link :to="{
                  name: 'about',
                  params: { storeName: this.$store.storeName, lang: $i18n.locale },
                }"  @click.native="closeOffcanvas"  class="nav-link py-2">
                {{ $t('about') }}</router-link></li>

 <li><a v-if="$i18n.locale == 'ar'" @click="onChange('en');activeMobile = false" class="nav-link py-2"  @click.native="closeOffcanvas">English</a></li>
  <li><a v-if="$i18n.locale == 'en'" @click="onChange('ar');activeMobile = false" class="nav-link py-2"  @click.native="closeOffcanvas">العربية</a></li>
   <li>
    <router-link v-if="this.$localStorage.get(this.$store.storeName) == null"  :to="{
              name: 'login',
              params: { storeName: this.$store.storeName,lang: $i18n.locale },
            }"   @click.native="closeOffcanvas" class="btn btn-link text-dark me-2 p-0 ms-3  d-md-inline">
        <i class="bi bi-person" style="font-size: 1.5rem; color: #857e7e;"></i>
        {{ $t('login') }}
      </router-link>

       <router-link v-else :to="{
              name: 'profile',
              params: { storeName: this.$store.storeName,lang: $i18n.locale },
            }"
             class="btn btn-link text-dark me-2 p-0 ms-3  d-md-inline"  @click.native="closeOffcanvas">
        <i class="bi bi-person" style="font-size: 1.5rem; color: #857e7e;"></i>
        {{ $t('profile') }}
       </router-link>
       </li>

    </ul>

  <!-- show sections -->
    <!-- الروابط -->
    <ul v-if="show2" class="list-unstyled mt-2">
            <li><a @click="show2=false;show=true" class="nav-link py-2">{{$t('return')}} 
              <span class="float-end arrow_right"> →</span>
              <span class="float-end arrow_left"> ←</span>
            </a></li>

      <li v-for="(item, index) in this.sections">
        <router-link   @click.native="closeOffcanvas" class="nav-link py-2 " 
               :to="{
                      name: 'section',
                      params: {
                        storeName: $store.storeName,
                        id: item.id,
                        name: item.name,
                        lang: $i18n.locale
                      },}">

                  {{ item.name}}
                </router-link></li>
    </ul>

    <!-- إنستقرام -->
    <ul class="list list-social list-unstyled" v-if="DBitems.social">
        <li class="list-social__item">
       <a v-if="DBitems.social.instgram" target="_blank" :href="DBitems.social.instgram">
              <i class="bi bi-instagram"></i>  
            </a>
             </li>
               <li class="list-social__item">
            <a v-if="DBitems.social.twiter" target="_blank" :href="DBitems.social.twiter"
              ><i class="bi bi-twitter-x" ></i></a>
              </li>
               <li class="list-social__item">
            <a v-if="DBitems.social.facebook" target="_blank" :href="DBitems.social.facebook"
              ><i class="bi bi-facebook" ></i></a>
              </li>

               <li class="list-social__item">
             <a v-if="DBitems.social.tiktok" target="_blank" :href="DBitems.social.tiktok">
              <i class="bi bi-tiktok" ></i></a>
              </li>
               <li class="list-social__item">
            <a v-if="DBitems.social.whatsapp" target="_blank" :href="'https://api.whatsapp.com/send?phone='+DBitems.social.whatsapp+'&text=Hello!'"
              > <i class="bi bi-whatsapp" ></i></a></li>
               <li class="list-social__item">
            <a v-if="DBitems.social.snapchat" target="_blank" :href="DBitems.social.snapchat"
              ><i class="bi bi-snapchat" ></i></a></li>

               <li class="list-social__item">
              <a v-if="DBitems.social.email" target="_blank" :href="'mailto:'+DBitems.social.email"
              ><i class="bi bi-envelope" ></i></a>
              </li>
                  <li class="list-social__item">
              <a v-if="DBitems.social.phone" target="_blank" :href="'to:'+DBitems.social.phone"
              ><i class="bi bi-telephone-outbound" ></i></a>
              </li>
    </ul>
  </div>
   <!-- end show sections -->
</div>
    </div>
    </template>

    <script>
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
export default {
  // eslint-disable-next-line
  /*eslint-disable */
  name: "Header",
  props: {
    // name: String,
    // image: String
    storeName: String
  },
  data: function () {
    return {
      loading: true,
      loadingNote: false,
      activeMobile: false,
      word: "",
      show: true,
      show1: false,
      show2: false,
      deleteNoteId: null,
      deleteNoteIndex: null,
      notifications: [],
      countries: [],
      country: 6,
      sections: [],
      show_section: false,
      search_open:false,
      DBitems:null,
    };
  },
computed: {
    isHomePage() {
      return this.$route.path === '/';
    },
    navStyle() {
      return {
        paddingTop: '30px',
        paddingBottom: this.isHomePage ? '60px' : '20px',
        backgroundColor: '#FCFEF1'
      };
    }
  },
  watch: {
    myState: function (newVal, oldVal) {
      console.log(this.$store.notificationUpdate + " hiiiiiiiiiiii ");
      if (this.$localStorage.get(this.$store.storeName) != null) {
        this.loadingNote = true;
        this.axios
          .get(
            this.$store.state.base_api_url +
            this.$store.storeName +
            "/new_note",
            {
              headers: {
                "Accept-Language": this.$i18n.locale,
                Authorization:
                  "Bearer " + this.$localStorage.get(this.$store.storeName)
              }
            }
          )
          .then(response => {
            if (response.data.data.code == "1") {
              this.notifications = response.data.data.notes;
              console.log("heeeeeeeeeeeeeeeeeeee " + this.notifications);
            }
          })
          .then((this.loadingNote = false));
      }
    }
  },
  created() {
    if (this.$route.params.lang && this.$route.params.lang != this.$i18n.locale) {
      this.$i18n.locale = this.$route.params.lang;
      this.$store.state.UnitPrice = this.$store.state.unitAR
      if (this.$i18n.locale == 'en') {
        document.documentElement.setAttribute("dir", "ltr");
        let h = document.querySelector('body');
        this.$store.state.UnitPrice = this.$store.state.unit
      }
    }
    this.axios
      .get(
        this.$store.state.base_api_url +
        this.$store.storeName +
        "/sections_theme2",
        {
          headers: {
            "Accept-Language": this.$i18n.locale,
          },
        }
      )
      .then((response) => {
        this.sections = response.data.data;
      })
      .then(() => (this.loading = false));
    //////////////////////////////////////

        this.axios
      .get(this.$store.state.base_api_url + this.$store.storeName + "/footer",
      {
          headers: {
            "Accept-Language": this.$i18n.locale,
          },
        })
      .then((response) => (this.DBitems = response.data.data))
      .then(() => (this.loading = false));
    //////////////////////////
    console.log('///////////////////////////////////////////////////////////////////////////////////')
    this.axios
      .get(
        this.$store.state.base_api_url + this.$store.storeName + "/market_countries",
        {
          headers: {
            "Accept-Language": this.$i18n.locale
          }
        }
      )
      .then(response => {
        this.countries = response.data.data;
        console.log('gggg', this.countries)

      })
      .then(() => (this.loading = false));
    ///////////////////////////////

    ///////////////////////////////////////////////////////////

    let AllCookies = this.$cookies.keys();
    let counter = 0;
    for (let i = 0; i < AllCookies.length; i++) {
      if (AllCookies[i].split("/")[0] == this.$store.storeName) {
        counter++;
        //console.log(this.items);
      }
    }
    this.$store.state.cartCounter = counter;

    console.log(counter);
    this.loading = false;
  },
  methods: {
    closeOffcanvas() {
    const offcanvasEl = document.querySelector('.offcanvas.show');
    if (offcanvasEl) {
      const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl);
      if (bsOffcanvas) {
        bsOffcanvas.hide();
      }
    }
  },
    change_country() {
      //////////////////////////
      console.log('///////////////////////////////////////////////////////////////////////////////////')
      console.log(this.country)
      this.axios
        .get(
          this.$store.state.base_api_url + this.$store.storeName + "/currencyv1/" + this.country,
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          this.$store.state.rate = response.data.data.rate
          this.$store.state.unit = response.data.data.unit_en
          this.$store.state.unitAR = response.data.data.unit_ar
          this.$store.state.country_code = response.data.data.country_code;
          this.$store.state.country_flag = response.data.data.country_flag;
          this.$store.state.country_length = response.data.data.country_length;
          if (this.$i18n.locale == 'ar') {
            this.$store.state.UnitPrice = this.$store.state.unitAR;
          }
          else {
            this.$store.state.UnitPrice = this.$store.state.unit;
          }

        })
        .then(() => (this.loading = false));


      ///////////////////////////////
    },
    onChange(lang) {
      this.$store.state.langchange = true;
      this.$store.state.langchange1 = true; //for footer
      this.$i18n.locale = lang;
      this.$router.replace({ params: { lang: this.$i18n.locale } })

      this.axios
        .get(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/sections_theme2",
          {
            headers: {
              "Accept-Language": this.$i18n.locale,
            },
          }
        )
        .then((response) => {
          this.headerSections = response.data.data;
        })
        .then(() => (this.loading = false));

      this.axios
        .get(
          this.$store.state.base_api_url +
          this.$store.storeName +
          "/market_countries",
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          this.countries = response.data.data;
          if (this.$i18n.locale == 'ar') {
            this.$store.state.UnitPrice = this.$store.state.unitAR;
          }
          else {
            this.$store.state.UnitPrice = this.$store.state.unit;
          }

        })
        .then(() => (this.loading = false));
      if (lang == "ar") {
        document.documentElement.setAttribute("dir", "rtl");
        let h = document.querySelector('body');
        h.setAttribute('dir', 'rtl')

        document.title = this.$store.state.title_ar;
        document.getElementById("description_meta").content = this.$store.state.description_ar;
        document.getElementById("keywords_meta").content = this.$store.state.keyword_ar;
      } else {
        document.documentElement.setAttribute("dir", "ltr");
        let h = document.querySelector('body');
        h.setAttribute('dir', 'ltr')

        document.title = this.$store.state.title_en;
        document.getElementById("description_meta").content = this.$store.state.description_en;
        document.getElementById("keywords_meta").content = this.$store.state.keyword_en;
      }
    
    },
   
    searchRoute() {
      this.search_open=false;
      if (this.$route.path.includes("/" + this.$store.storeName + "/Search")) {
        console.log(this.word + "hiiiiiii");
        this.$router.push({ name: "search", params: { word: this.word, lang: this.$i18n.locale } });
      } else {
        this.$router.push({
          name: "search",
          params: { storeName: this.$store.storeName, word: this.word, lang: this.$i18n.locale }
        });
      }
    },
   
   
   
    
  }
};
</script>